import httpRequest from "@/shared/services/httpRequest";
import { StandardResponse } from "@/shared/services/response.model";
import { API_ENDPOINTS } from "@/shared/constants";
import {
  NotificationSearchRequest,
  NotificationSearchResponse,
  FailedNotificationResponse,
  AcknowledgeNotificationRequest,
  AcknowledgeNotificationResponse,
} from "../types/Notification.type";

export const getFailedNotifications = async (): Promise<
  StandardResponse<FailedNotificationResponse["data"]>
> => {
  return await httpRequest.get<FailedNotificationResponse["data"]>(
    API_ENDPOINTS.reports.notification.failed,
  );
};

export const searchNotifications = async (
  request: NotificationSearchRequest,
): Promise<StandardResponse<NotificationSearchResponse["data"]>> => {
  return await httpRequest.post<
    NotificationSearchResponse["data"],
    NotificationSearchRequest
  >(API_ENDPOINTS.reports.notification.search, request);
};

export const acknowledgeNotifications = async (
  request: AcknowledgeNotificationRequest,
): Promise<StandardResponse<AcknowledgeNotificationResponse["data"]>> => {
  return await httpRequest.post<
    AcknowledgeNotificationResponse["data"],
    AcknowledgeNotificationRequest
  >(API_ENDPOINTS.reports.notification.updateStatus, request);
};
